var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.37641 14.7617C8.5756 14.5624 8.6875 14.2922 8.6875 14.0105C8.6875 13.7287 8.5756 13.4585 8.37641 13.2593L3.11704 7.99992L8.37641 2.74055C8.56996 2.54016 8.67705 2.27177 8.67463 1.99318C8.67221 1.7146 8.56047 1.44811 8.36347 1.25111C8.16648 1.05412 7.89999 0.942376 7.6214 0.939956C7.34282 0.937534 7.07443 1.04463 6.87404 1.23817L0.863476 7.24873C0.664288 7.44798 0.55239 7.71818 0.55239 7.99992C0.55239 8.28166 0.664288 8.55186 0.863476 8.75111L6.87404 14.7617C7.07329 14.9609 7.34349 15.0728 7.62523 15.0728C7.90696 15.0728 8.17717 14.9609 8.37641 14.7617Z",
    fill: "#535870"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.631c95992447ee724a59008cc164062e.svg";
export { ForwardRef as ReactComponent };